import Stack from '@mui/material/Stack'

import Image from '@shared/components/src/Image'

import ImageFullScreenViewer from '@components/ImageFullScreenViewer'
import RenderControl from '@components/RenderControl'

export default function InsuranceDetailed({ data, isLoading }) {
  return (
    <RenderControl
      loading={isLoading}
      isEmpty={!isLoading && !data?.frontUrl && !data?.backUrl}
      emptyTitle="No images available"
      emptyProps={{ variant: 'h4', color: 'text.primary' }}
    >
      <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', p: 4 }}>
        {data?.frontUrl && (
          <ImageFullScreenViewer image={data.frontUrl}>
            {(view) => (
              <Image
                fit="contain"
                src={data.frontUrl}
                duration={500}
                width="unset"
                onClick={view}
                sx={{ maxWidth: 300, maxHeight: 200, minHeight: 100, cursor: 'pointer' }}
                alt="front of insurance card"
              />
            )}
          </ImageFullScreenViewer>
        )}
        {data?.backUrl && (
          <ImageFullScreenViewer image={data.backUrl}>
            {(view) => (
              <Image
                fit="contain"
                src={data.backUrl}
                duration={500}
                width="unset"
                onClick={view}
                sx={{ maxWidth: 300, maxHeight: 200, minHeight: 100, cursor: 'pointer' }}
                alt="back of insurance card"
              />
            )}
          </ImageFullScreenViewer>
        )}
      </Stack>
    </RenderControl>
  )
}
